import React from "react";
import { Field } from "redux-form";

import { ASSET_TYPES } from "utils/constants";

import DynamicAssetSelect from "social/DynamicAssetSelect";
import DynamicInput from "social/DynamicInput";
import { useSocialFields } from "social/formats/utils";

import { MAX_IMAGE_BYTES } from "./consts";
import { formatBytes } from "utils/common";
import { isRequiredAssetField } from "social/utils";
import { imposiumComposition } from "social/ImposiumCompSelector";

const IMAGE_ACCEPT = ".jpg, .jpeg, .png";

const FILE_SIZE_REQUIREMENT = { name: "File Size:", description: `${formatBytes(MAX_IMAGE_BYTES)} Maximum` };
const FILE_TYPE_REQUIREMENT = { name: "File Types:", description: IMAGE_ACCEPT };
const ASPECT_RATIO_REQUIREMENT = { name: "Aspect Ratio:", description: "9:16" };

const varNamePrefix = "fb_reels_";

export default function FacebookReels(props){
	const {
		libraryId,
		navigationActions,
		creativeAssetType,
	} = props;

	const baseFields = {
		imposiumComposition,
		image: {
			name: "image",
			label: "Image",
			className: "full-width",
			assetType: ASSET_TYPES.IMAGE,
			component: DynamicAssetSelect,
			defaultDynVarName: `${varNamePrefix}product`,
			dynamicToggleDisabled: true, // Only the default placement is allowed to toggle dynamic status on asset fields.
			requirements: [
				FILE_SIZE_REQUIREMENT,
				FILE_TYPE_REQUIREMENT,
				ASPECT_RATIO_REQUIREMENT,
				{ name: "Dimensions:", description: "600x600 pixels or larger required" }
			],
			creativeAssetType,
			required: isRequiredAssetField(creativeAssetType),
			accept: IMAGE_ACCEPT,
			tip: {
				direction: "top",
				description: "At least 600x600 for better placement compatibility",
			},
			libraryId,
			navigationActions,
		},
		primaryText: {
			name: "primaryText",
			label: "Primary Text",
			className: "full-width",
			placeholder: "Tell people what your creative is about",
			tip: {
				description: "May get truncated after 125 characters",
				direction: "right",
			},
			component: DynamicInput,
			type: "textarea",
			defaultDynVarName: `${varNamePrefix}copy`,
		},
		landingPage: {
			name: "landingPage",
			label: "Landing Page",
			className: "full-width",
			placeholder: "https://www.example.com",
			component: DynamicInput,
			defaultDynVarName: `${varNamePrefix}clickTag1`,
			required: true,
		},
	};

	const fieldProps = useSocialFields(baseFields, props);

	return (
		<div className="fields">
			{fieldProps.map((properties) => {
				return <Field key={properties.name} {...properties} />;
			})}
		</div>
	);
}

FacebookReels.displayName = "FBImageMOFacebookReelsPlacement";
